export default __webpack_public_path__ + "static/media/team2.c9838ad9.png";